var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('Header'),_vm._v(" "),_c('div',{staticClass:"about"},[_c('Main'),_vm._v(" "),_c('Tiles')],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('FooterComponent')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6f7395c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/about/About.vue
// module id = null
// module chunks = 